import { Component, EventEmitter, Output } from "@angular/core";
import { noInternet, noInternetMessage, retry } from "@constants";
import { IonicModule } from "@ionic/angular";

@Component({
  selector: "no-internet",
  standalone: true,
  templateUrl: "./no-internet.html",
  styleUrls: ["./no-internet.scss"],
  imports: [IonicModule],
})
export class NoInternet {
  @Output() onRetry = new EventEmitter<void>();

  get noInternet() {
    return noInternet;
  }

  get noInternetMessage() {
    return noInternetMessage;
  }

  get retryText() {
    return retry;
  }

  retry() {
    this.onRetry.emit();
  }
}
